import { CategoryService } from '@core/services';
import { Inject } from '@rxdi/core';
import { Component, html } from '@rxdi/lit-html';

/**
 * @customElement app-component
 */
@Component({
  selector: 'app-component',
  template() {
    return html`
      <router-outlet>
        <navbar-component slot="header"></navbar-component>
        <footer-component slot="footer"></footer-component>
      </router-outlet>
    `;
  },
  container: document.body,
})
export class AppComponent extends HTMLElement {
  @Inject(CategoryService)
  private categoryService: CategoryService;

  OnInit() {
    // Preload endpoints for performance
    this.performanceOptimization();

    const loadingElement = document.querySelector('loading-screen-component');
    loadingElement?.remove();
  }

  performanceOptimization() {
    this.categoryService.listCategories().subscribe();
  }
}
